import { render, staticRenderFns } from "./mySampleInfor.vue?vue&type=template&id=4f3f8447&scoped=true&"
import script from "./mySampleInfor.vue?vue&type=script&lang=js&"
export * from "./mySampleInfor.vue?vue&type=script&lang=js&"
import style0 from "./mySampleInfor.vue?vue&type=style&index=0&id=4f3f8447&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f8447",
  null
  
)

export default component.exports